import { useEffect } from 'react'

const DEFAULT_SUFFIX = 'PressOne AI'

/**
 * Sets `document.title` to `"<title> · PressOne AI"` while the calling
 * component is mounted, and restores the previous title on unmount.
 *
 * Pass `null` to skip (useful when the title depends on async-loaded data
 * that isn't ready yet).
 */
export function useDocumentTitle(title: string | null | undefined, suffix: string = DEFAULT_SUFFIX) {
  useEffect(() => {
    if (!title) return
    const previous = document.title
    document.title = `${title} · ${suffix}`
    return () => {
      document.title = previous
    }
  }, [title, suffix])
}
